// JSON-LD structured-data builders for rich results in Google.
import { SITE_URL } from '../components/Seo';

export interface Faq {
  q: string;
  a: string;
}

export function softwareApplicationSchema(opts: {
  name: string;
  description: string;
  path: string;
}) {
  return {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name: opts.name,
    url: `${SITE_URL}${opts.path === '/' ? '' : opts.path}`,
    applicationCategory: 'DeveloperApplication',
    operatingSystem: 'Any (web browser)',
    description: opts.description,
    offers: {
      '@type': 'Offer',
      price: '0',
      priceCurrency: 'USD',
    },
  };
}

export function faqPageSchema(faqs: Faq[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((f) => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: { '@type': 'Answer', text: f.a },
    })),
  };
}

export function breadcrumbSchema(items: { name: string; path: string }[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: item.name,
      item: `${SITE_URL}${item.path === '/' ? '' : item.path}`,
    })),
  };
}

export function articleSchema(opts: {
  headline: string;
  description: string;
  path: string;
  datePublished: string;
  dateModified: string;
}) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: opts.headline,
    description: opts.description,
    mainEntityOfPage: `${SITE_URL}${opts.path}`,
    author: { '@type': 'Organization', name: 'EasyBase64' },
    publisher: {
      '@type': 'Organization',
      name: 'EasyBase64',
      logo: { '@type': 'ImageObject', url: `${SITE_URL}/logo512.png` },
    },
    datePublished: opts.datePublished,
    dateModified: opts.dateModified,
  };
}
